// Definición de un componente funcional
import React, {useContext, useEffect, useRef, useState} from "react";
import { useTranslation } from "react-i18next";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {updateCorridorLength} from "../../helpers/ApiRequests";
import {KeycloakContext} from "../../context/KeycloakContext";
import {Toast} from "primereact/toast";

const CorridorForm = ({ onClose, data, reference_id }) => {
    const { kc } = useContext( KeycloakContext )
    const [ reference, setReference] = useState(data.ReferenceName);
    const [mimetikaId, setMimetikaId] = useState(reference_id);
    const [ vertexDistance, setVertexDistance ] = useState(data.BVD);
    const [ pantoscopicAngle, setPantoscopicAngle ] = useState(data.PantoAngle);
    const [ miCorridor, setMiCorridor ] = useState(data.Corridor);
    const { t } = useTranslation();
    const toast = useRef(null);

    const calculate = async () => {
        const response = await updateCorridorLength(kc, mimetikaId, vertexDistance, pantoscopicAngle, toast, t)
        if (response) setMiCorridor(response.Corridor)
    }

    return (
        <div className="account-settings text-left overflow-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 m-0 pb-4">
                <label className="text-sm sm:text-base	uppercase my-auto">{ t('Reference') }:</label>
                <InputText readOnly={true} className={ classes } value={ reference } onChange={(e) => setReference(e.target.value)} placeholder={t('Reference')} />

                <label className="text-sm sm:text-base	uppercase my-auto">{ t('MeasurementUUID') }:</label>
                <InputText readOnly={true} className={ classes } value={ mimetikaId } onChange={(e) => setMimetikaId(e.target.value)} placeholder={t('MeasurementUUID')} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 m-0 py-4 corridor-calculate-form border-y-1">
                <div className="max-w-44" ><label className="text-sm sm:text-base uppercase my-auto max-w-40">{ t('Vertex distance') }:</label></div>
                <div className="col-span-1 md:col-span-2">
                    <InputText className={ classes } value={ vertexDistance } onChange={(e) => setVertexDistance(e.target.value)} placeholder={t('Vertex distance')} />
                </div>

                <div className="max-w-44"><label className="text-sm sm:text-base uppercase my-auto max-w-40">{ t('Pantoscopic angle') }:</label></div>
                <div className="col-span-1 md:col-span-2">
                    <InputText className={ classes } value={ pantoscopicAngle } onChange={(e) => setPantoscopicAngle(e.target.value)} placeholder={t('Pantoscopic angle')} />
                </div>
                <div />
                <Button onClick={calculate} className="text-center btn-1 w-auto sm:w-1/4"  label={t('Calculate')} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 m-0 pt-4">
                <label className="text-sm sm:text-base	uppercase my-auto">{ t('MiCorridor') }:</label>
                <InputText readOnly={true} className={ classes } value={ miCorridor } onChange={(e) => setMiCorridor(e.target.value)} placeholder={t('MiCorridor')} />
                <div />
            </div>

            <div className="absolute top-4 right-6 sm:right-4 cursor-pointer opacity-80" onClick={ onClose }> <li className="pi pi-times" /> </div>
            <Toast ref={toast} />
        </div>
    );
}

const classes = `col-span-1 md:col-span-2 text-xs p-2 w-48 sm:60 md:w-72 lg:w-80 xl:w-80 2xl:w-96`


export default CorridorForm;
